import { createSelector } from 'reselect'

export const getLocationsByCity = createSelector(
  (state) => state.geoObjects && state.geoObjects.locations && state.geoObjects.locations.byCity
    ? state.geoObjects.locations.byCity
    : {},
  (locations) => locations
)
